import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        bold: {
            fontWeight: 700,
        },
        container: {
            alignItems: 'flex-start',
        },
    }
})

export default useStyles
